(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (() => {
    const selector = '[data-hauck-contact-message]';
    function validateMessage(field) {
      field.setCustomValidity(field.value.trim() ? '' : field.dataset.requiredMessage);
    }
    function initialize() {
      document.querySelectorAll(selector).forEach(validateMessage);
    }
    document.addEventListener('input', (event) => {
      if (event.target instanceof HTMLTextAreaElement && event.target.matches(selector)) {
        validateMessage(event.target);
      }
    });
    document.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      const field = event.target.querySelector(selector);
      if (!field) return;
      validateMessage(field);
      if (!field.validity.valid) {
        event.preventDefault();
        field.reportValidity();
      }
    }, true);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();
})();
